import React from 'react';
import { Form, Col, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import FormActions from '../../components/FormActions';
import IsValidName from '../../../../utils/validators/IsValidName';
import { QuizApiService } from '../../../../services/Ananse/QuizApiService';
import Loading from '../../../home/components/Loading';
import { connect } from "react-redux";
import SelectSearchComponent from '../../../auth/Components/Select2';
import SelectLanguage from '../../components/SelectLanguage';

const initialState = {
  name: '',
  campaignId: null,
  campaignName: '',
  languageName: '',
  resetInput: false
}

class QuizForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      language: this.convertLanguage()
    };

    this.api = new QuizApiService();

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.onCleanForm = this.onCleanForm.bind(this);
    this.formIsValid = this.formIsValid.bind(this);
    this.submit = this.submit.bind(this);
    this.afterSubmit = this.afterSubmit.bind(this);
  }

  submit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    try {
      const reqBase = { method: 'POST' }
      const { name, campaignId, language } = this.state;

      const result = await this.api.makeHttpRequest({
        ...reqBase,
        data: {
          name,
          campaignId,
          language
        }
      });

      this.afterSubmit(result);
    } catch (e) {
      Swal.fire(
        this.props.translate.defaultMessages.error,
        e.response && e.response.status === 400
          ? e.response.data
          : this.props.translate.screens.quiz.errors.create,
        'error'
      );
    }

    this.setState({ isLoading: false });
  }

  afterSubmit = async (result) => {
    this.setState({
      ...initialState,
      resetInput: true
    });

    this.props.history.push('/admin/quiz/' + result.quizId + '/update');
  }

  handleChangeLanguage = e => {
    this.setState({ language: e.value });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleChangeSelect = (e) => {
    this.setState({
      campaignId: e.id,
      campaignName: e.label,
      resetInput: false
    });
  }

  formIsValid = () => {
    const { name, campaignId } = this.state;
    const isValid = (IsValidName(name)
      && campaignId !== null);
    return isValid;
  }

  onCleanForm = async () => {
    this.setState({
      ...initialState,
      resetInput: true,
      resetInputFilial: true,
    });
  }

  convertLanguage() {
    let { lang } = this.props;

    switch (lang) {
      case 'pt': return 'pt-BR';
      case 'en': return 'en-US';
      case 'es': return 'es-ES';
      default: return 'en-US';
    }
  }

  render() {
    window.setPageTitle(`${this.props.translate.screens.quiz.pageTitle.create} - Admin`);

    const {
      name,
      resetInput
    } = this.state;

    return (
      <Card className='mt-3'>
        <Loading isLoading={this.state.isLoading} />
        <Card.Header>
          {this.props.translate.screens.quiz.headerTitle}
        </Card.Header>
        <Card.Body>
          <Form onSubmit={this.submit} >
            {/* row 1 */}
            <Form.Row>
              {/* Nome */}
              <Form.Group as={Col} lg='4' xs='12'>
                <Form.Label>
                  {this.props.translate.screens.quiz.labels.name} *
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete='off'
                  name='name'
                  placeholder={this.props.translate.screens.quiz.placeholders.name}
                  maxLength='100'
                  value={name}
                  isInvalid={name && !IsValidName(name)}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>


              {/* Campanha */}
              <Form.Group as={Col} lg='4' xs='12'>
                <Form.Label>
                  {this.props.translate.screens.quiz.labels.campaign} *
                </Form.Label>
                <SelectSearchComponent
                  resetInput={resetInput}
                  required={true}
                  handleChange={(e) => this.handleChangeSelect(e)}
                  className="kt-width-full"
                  label={this.props.translate.screens.quiz.placeholders.campaign}
                  url={`/campaigns/without-quiz?str=`}
                  convertObject={obj => ({ id: obj.campaignId, value: obj.campaignId, label: `${obj.name}`, obj })}
                />
              </Form.Group>

              {/* Nome */}
              <Form.Group as={Col} lg='4' xs='12'>
                <Form.Label>
                  {this.props.translate.screens.quiz.labels?.language}
                </Form.Label>
                <SelectLanguage 
                  translate={this.props.translate} 
                  handleChangeLanguage={this.handleChangeLanguage}
                  languageValue={this.state.language}
                />
              </Form.Group>
            </Form.Row>

            <FormActions
              module='quiz'
              isEdit={false}
              formIsValid={this.formIsValid()}
              onCleanForm={this.onCleanForm}
              submitLabel={this.props.translate.buttons.save}
            />
          </Form>
        </Card.Body>
      </Card>
    )
  }
}

const mapStoreToProps = store => ({
  i18n: store.i18n
});

export default connect(mapStoreToProps, null)(QuizForm);